import { PropsWithChildren } from "react";

import { useMeuPlayState } from "@src/states/meuplay";

export function ValidRender({ children }: PropsWithChildren) {
  const isValid = useMeuPlayState((state) => state.isValid);
  if (isValid) return children;

  // Reaproveita o visual da tela de carregamento pré-React (`.no-react` do
  // index.html): fundo preto, texto branco, centralizado no viewport.
  return (
    <div className="no-react">
      <p>Validando sessão...</p>
    </div>
  );
}
